import { Button } from '@cambridgeassessment/cambridge-ui';
import { NavigateBeforeRounded } from '@material-ui/icons';
import React, { memo, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGoBackButton } from './styles';

interface GoBackButtonProps {
  defaultPath?: string;
}

const GoBackButton: React.FC<GoBackButtonProps> = ({ defaultPath }) => {
  const classes = useGoBackButton();
  const history = useHistory();
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    const hasHistory = window.history.length > 1;

    const referrer = document.referrer;
    const hasReferrer = referrer && referrer.includes(window.location.host);

    setCanGoBack(hasHistory && hasReferrer);
  }, []);

  const handleGoBack = () => {
    if (canGoBack) {
      history.goBack();
    } else {
      history.push(defaultPath || '/organisation?tab=users');
    }
  };

  return (
    <Button
      className={classes.button}
      style={{ color: '#00588f' }}
      tabIndex={0}
      data-testid="back-link"
      onClick={handleGoBack}
      variant="text"
      size="small"
    >
      <NavigateBeforeRounded /> Go back
    </Button>
  );
};

export default memo(GoBackButton);
